import React from 'react';
import { PushNotifications } from '@capacitor/push-notifications';
// import { Toast } from "@capacitor/toast";\
import { toast } from 'react-toastify';
import FCMActions from 'redux/reducers/gl_fcm_reducer/actions';
import store from 'redux/store';
import { StateStatus } from 'redux/utils/common';

const addListeners = async () => {
  await PushNotifications.addListener('registration', (token) => {
    console.info('Registration token-->: ', token.value);
    store.dispatch(
      FCMActions.setFCMTokenlAction({
        token: token.value,
        status: StateStatus.Success,
      })
    );
  });

  await PushNotifications.addListener('registrationError', (err) => {
    console.error('Registration error: ', err.error);
    store.dispatch(
      FCMActions.setFCMTokenlAction({
        status: StateStatus.Failed,
      })
    );
  });

  await PushNotifications.addListener(
    'pushNotificationReceived',
    (notification) => {
      console.log('Push notification received: ', notification);
    }
  );

  await PushNotifications.addListener(
    'pushNotificationActionPerformed',
    (notification) => {
      console.log(
        'Push notification action performed',
        notification.actionId,
        notification.inputValue
      );
    }
  );
};

const registerNotifications = async () => {
  let permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive !== 'granted') {
    throw new Error('User denied permissions!');
  }

  await PushNotifications.register();
};

const showToast = async (msg: string) => {
  //   await Toast.show({
  //     text: msg,
  //   });
  toast(msg);
};

const getDeliveredNotifications = async () => {
  const notificationList = await PushNotifications.getDeliveredNotifications();
  console.log('delivered notifications', notificationList);
};

// addListeners();

// https://gist.github.com/enappd/b36ecc2951d7f52f1980e3d00a87acb3
const NotificationProvider = () => {
  React.useEffect(() => {
    registerNotifications()
      .catch((err) => {
        showToast(err.message);
      })
      .then(() => {
        console.log('Register successfuly!!');
        addListeners();
      });
  }, []);

  return null;
};

export default React.memo(NotificationProvider);
